export default __webpack_public_path__ + "87a50771835dfd7cf427dc29b7116115.png";